import React from 'react';
import { DashboardProvider } from '../context/DashboardContext';
import DashboardShell from '../components/dashboard/DashboardShell';

// Main Dashboard Page - Wraps with DashboardProvider for role-based access
const Dashboard = () => (
  <DashboardProvider>
    <DashboardShell />
  </DashboardProvider>
);

export default Dashboard;
